// Utilities & frameworks
window.$.fn.select2.defaults.set("language", Locale.getLocale());
